import { GenericDialog } from "../dialogs";
import { SignatureEntryProps } from "./SignatureEntry";
import { useEffect, useState } from "react";
import { useGetUserSignatures } from "@/queries/user.queries";
import { UserSignature } from "@/api/user";

export type SignatureSelectionProps = SignatureEntryProps & {
  onAccept: (signature?: UserSignature) => void;
};

export function SignatureSelection(props: SignatureSelectionProps) {
  const signatures = useGetUserSignatures();
  const [selectedSignature, setSelectedSignature] = useState<UserSignature>();

  useEffect(() => {
    if (signatures.isSuccess && signatures.data.length > 0) {
      setSelectedSignature(signatures.data[0]);
    }
  }, [signatures.data]);

  return (
    <GenericDialog
      buttons="OKCancel"
      caption={props.type === "Revalidation" ? "Revalidate certificate?" : "Sign Record?"}
      onAccept={() => props.onAccept(selectedSignature)}
    >
      <div className="me-5">
        {props.type === "Record" && <p>Are you sure you want to sign signature {props.signature.title}?</p>}
        {props.type === "Revalidation" && <p>Are you sure you want to revalidate this certificate?</p>}

        {signatures.isSuccess &&
          signatures.data.length > 1 &&
          signatures.data.map((signature) => (
            <div key={signature.userSignatureId} className="mb-2">
              <input
                type="radio"
                name="signature"
                className="form-check-input align-middle"
                checked={signature === selectedSignature}
                onChange={() => setSelectedSignature(signature)}
              ></input>
              <img
                src={signature.signature}
                width="150"
                height="50"
                className="user-signature ms-3"
                onClick={() => setSelectedSignature(signature)}
              />
            </div>
          ))}
      </div>
    </GenericDialog>
  );
}
